import { render, staticRenderFns } from "./15introduce.vue?vue&type=template&id=6481a9f0&scoped=true&"
import script from "./15introduce.vue?vue&type=script&lang=js&"
export * from "./15introduce.vue?vue&type=script&lang=js&"
import style0 from "./15introduce.vue?vue&type=style&index=0&id=6481a9f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6481a9f0",
  null
  
)

export default component.exports